// Grouped client for CatalogFeed operations
import { ApiConfiguration } from '../ApiConfiguration';
import { Form } from '../models/Form';
import { CatalogFeed } from '../models/CatalogFeed';
import { FilterCatalogFeedRequest } from '../models/FilterCatalogFeedRequest';
import { DataviewCatalogFeedResponse } from '../models/DataviewCatalogFeedResponse';
import { FormSerializer } from '../serializers/FormSerializer';
import { CatalogFeedSerializer } from '../serializers/CatalogFeedSerializer';
import { FilterCatalogFeedRequestSerializer } from '../serializers/FilterCatalogFeedRequestSerializer';
import { DataviewCatalogFeedResponseSerializer } from '../serializers/DataviewCatalogFeedResponseSerializer';

/**
 * HTTP client for CatalogFeed operations
 *
 * Client for CatalogFeed operations
 */
export class CatalogFeedClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getFormForCatalogFeed(formName: string, objectId: string, name?: string | null, description?: string | null, isActive?: boolean | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/CatalogFeed({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeCatalogFeed(formName: string, name?: string | null, description?: string | null, isActive?: boolean | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/CatalogFeed/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterCatalogFeed(request?: FilterCatalogFeedRequest | null, options?: { headers?: Record<string, string> }): Promise<CatalogFeed[]> {
    const path = '/app/api/Object/CatalogFeed/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCatalogFeedRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CatalogFeedSerializer.fromObject(item));
  }

  async recentCatalogFeed(request?: FilterCatalogFeedRequest | null, options?: { headers?: Record<string, string> }): Promise<CatalogFeed[]> {
    const path = '/app/api/Object/CatalogFeed/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCatalogFeedRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CatalogFeedSerializer.fromObject(item));
  }

  async dataViewCatalogFeed(request?: FilterCatalogFeedRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewCatalogFeedResponse> {
    const path = '/app/api/Object/CatalogFeed/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCatalogFeedRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewCatalogFeedResponseSerializer.fromObject(data);
  }

}
